import type { UserDto } from '@mathflat/domain/@entities/User'

import type { RestrictionType } from '../types/permission'
import maxios from '../utils/maxios'

/** 학생앱의 restrictions로 오버라이드 */
type StudentMeResponseDto = Omit<UserDto.MeResponseDto, 'restrictions'> & {
  restrictions?: RestrictionType[]
}

export const userApi = {
  getMe() {
    return maxios.get<StudentMeResponseDto>('/users/me')
  },
}
